<template>
    <section id="vue-weather">
        <p>In case of rain, the ceremony will be held at the Iowa Taproom.</p>
    </section>
</template>

<script>
export default {
    name: "weather-view"
}
</script>



// WEBPACK FOOTER //
// src/views/weather.vue?1a8a784c